import ScanQR from './scan-qr-page';

export default ScanQR;
